import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/zh-cn/industries/combination-products")({
  head: () => buildRouteHead("/zh-cn/industries/combination-products"),
  component: SolutionDetail,
});

